import { render, staticRenderFns } from "./TrustAccountLedger.vue?vue&type=template&id=812aac1a&scoped=true"
import script from "./TrustAccountLedger.vue?vue&type=script&lang=js"
export * from "./TrustAccountLedger.vue?vue&type=script&lang=js"
import style0 from "./TrustAccountLedger.vue?vue&type=style&index=0&id=812aac1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812aac1a",
  null
  
)

export default component.exports